import { apiSlice } from '../../api/apiSlice';
import {
    CountryWithOperatorsListParams,
    CountryWithOperatorsListResponse,
} from './countryWithOperatorsListApiSliceTypes';

const countryWithOperatorsListApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getCountryWithOperatorsList: builder.query<
            CountryWithOperatorsListResponse,
            CountryWithOperatorsListParams
        >({
            query: (params) => {
                return {
                    url: '/globals/countries-with-operators',
                    method: 'GET',
                    headers: {
                        'Accept-Language': params.acceptLanguage ?? 'en',
                    },
                };
            },

            providesTags: (response) => {
                return response
                    ? [
                          ...response.data.map((country) => ({
                              type: 'countries' as const,
                              id: country.id,
                          })),
                          { type: 'countries', id: 'LIST' },
                      ]
                    : [{ type: 'countries', id: 'LIST' }];
            },
        }),
    }),
    overrideExisting: true,
});

export const {
    useGetCountryWithOperatorsListQuery,
    useLazyGetCountryWithOperatorsListQuery,
} = countryWithOperatorsListApiSlice;
